import src from './source'

//获取发票云token
export const getInvoiceCloudToken = (params = {}) => {
    src.API_REQ.getInvoiceCloudToken(params).then(res => {
        let { invoiceCloud = false, errorInfo, status } = res;
        const { setInvoiceCloudInfo } = src.globalStore;
        if (status !== '-1') {
            if (invoiceCloud) { //发票云
                if (errorInfo) { //无权限

                } else {
                    setInvoiceCloudInfo({
                        token: res.token,
                        invoiceCloud: invoiceCloud,
                        jsUrl: res.jsUrl,
                        baseUrl: res.baseUrl,
                    })
                }
            }
        }
    })
}

//ecid转fid
export const getInvoiceFid = (params = {}) => {
    return new Promise(resolve => {
        src.API_REQ.getFidOrEcid(params).then(res => {
            resolve(res)
        })
    })
}


//发票云页面选中数据后的回调函数
const selectedCallback = (res) => {
    const { changeSingleFieldValue, fieldAttrMap } = src.layoutStore;
    if (src.isMobile) { //移动端发票云
        const { originParams = {} } = res;
        const { fieldMark } = originParams;
        const { invoices } = res;
        if (!fieldMark) return;
        if (res.type === "INVOICE") {
            const { invoices } = res;
            let fieldid = fieldMark.substr(0, 5);
            let rowIndex = -1;
            if (fieldid.indexOf("_") > -1) {
                fieldid = fieldid.split("_")[0];
                rowIndex = fieldid.split("_")[1];
            }
            const fieldAttr = fieldAttrMap.get(fieldid);
            let valueInfo = getInvoiceObj(invoices);
            changeSingleFieldValue(fieldMark, valueInfo, {});
            window.historyRoute.go(-1)
        } else if (res.type === "ON_SCAN_QRCODE") { //调用扫码
            scanQRCod(res);
        } else if (res.type === "ON_SELECT_INVOICE") { //选择发票   类型：1 微信  2 支付宝
            chooseInvoice(res);
        } else if (res.type === "ON_CHOOSE_IMAGE") { //拍照
            takePicture({rid:res.rid});
        }else if (res.type ==="ERROR"){
            if(res.ret == '-2'){
                sendResult('UPDATE_TOKEN');
            }
        }
    } else { //pc端发票云
        const { seq = {} } = res;
        const { fieldMark } = seq;
        if (res.type === "retData" && fieldMark) {
            const { datas } = res;
            let fieldid = fieldMark.substr(0, 5);
            let rowIndex = -1;
            if (fieldid.indexOf("_") > -1) {
                fieldid = fieldid.split("_")[0];
                rowIndex = fieldid.split("_")[1];
            }
            const fieldAttr = fieldAttrMap.get(fieldid);
            let valueInfo = getInvoiceObj(datas);
            changeSingleFieldValue(fieldMark, valueInfo, {});
            //关闭弹窗
            window.invoiceBrowser.close();
            window.invoiceBrowser = null;
        } else if (res.type === "close" && fieldMark) {
            window.invoiceBrowser.close();
            window.invoiceBrowser = null;
        }
    }
    if (res.type === "ERROR") {
        if (res.ret === -2) {//token失效
            getInvoiceCloudToken({ tokenUnusual: 1 });
        }
    }
}

// 绑定发票云message事件，监听发票云页面回传的数据
export const bindOnMessage = () => {
    window.top.addEventListener('message', receiver, false);
}

//解除绑定发票云message事件
export const unbindOnMessage = () => {
    window.top.removeEventListener('message', receiver, false);
}

const receiver = (event) => {
    let returnData = event.data;
    selectedCallback(returnData)
}

const getInvoiceObj = (datas = []) => {
    let ids = [];
    let names = [];
    let specialobj = [];
    if (src.isMobile) {
        datas.map(item => {
            ids.push(item.oaid);
            if (item.data && item.data.number) {
                names.push(item.data.number);
            } else {
                names.push(item.id);
            }
            specialobj.push({
                id: item.oaid,
                name: (item.data && item.data.number) ? item.data.number : item.id,
                prop: {
                    cloudId: item.id
                }
            })
        })
    } else {
        datas.map(item => {
            ids.push(item.oa.id);
            if (item.number) {
                names.push(item.number);
            } else {
                names.push(item.id);
            }
            specialobj.push({
                id: item.oa.id,
                name: item.number ? item.number : item.id,
                prop: {
                    cloudId: item.id
                }
            })
        })
    }
    return {
        value: ids.join(","),
        name: names.join(","),
        specialobj: specialobj
    }
}


//移动端含sdk处理

//判断em方法是否存在
const checkFnaJsApi = (type) => {
    const isExist = window.em && window.em.checkJsApi(type);
    if (!isExist && window.WeaverMobile && window.WeaverMobile.Toast) {
        window.WeaverMobile.Toast.fail(src.getLabel(525804, '对不起,暂不支持该应用'));
        return false;
    }else{
        return true;
    }
}

//发送数据到 iframe
const sendResult = (type, data) => {
    const { invoiceCloudInfo } = src.globalStore;
    switch (type) {
        case 'UPDATE_TOKEN':
            getInvoiceCloudToken({tokenUnusual:1},()=>{
                sendMessage({
                    type: 'UPDATE_TOKEN',
                    token: invoiceCloudInfo.token
                });
            })
            break;
        case 'SCAN_QRCODE':
            sendMessage(data)
            break;
        case 'SELECT_INVOICE':
            sendMessage(data)
            break;
    }
}

//统一发送数据
const sendMessage = (data) => {
    const { invoiceCloudInfo } = src.globalStore;
    let childFrame = document.getElementById("req_invoice_iframe");
    let url = invoiceCloudInfo.jsUrl;
    childFrame.contentWindow.postMessage(data, url);
}

//获取当前设备
const getEquipment = () =>{
    let u = window.navigator.userAgent;
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    let isEMobile = u.indexOf('E-Mobile') > -1;
	let isDT = u.indexOf('DingTalk') > -1;
    let reg = /MicroMessenger/i;
    let isWx = reg.test(u);
    if(!isWx){
        isWx = '';  //和微信无关
    }else{
        let isWxWork = u.match(/WxWork/i) == "wxwork";
        if(isWxWork){
            isWx = false; // 企业微信
        }else{
            isWx = true;    //微信
        }
    }
    let devNum = 0;  //0：PC    1：IOS   2：ANDROID   3：H5   4：企业微信APP   5：企业微信PC   6：微信公众号
    if(isWx === true ){
        devNum = 6;
    }else if(isWx === false){
        devNum = 4;
    }else if(isAndroid || isiOS){
        devNum = 3;
    }
    let equipment = {
        isAndroid:isAndroid,
        isiOS:isiOS,
        isEMobile:isEMobile,
        dev:devNum,
        isWx:isWx,
		isDT:isDT,
    }
    console.log('equipment',equipment);
    return equipment
}

//调用扫码
const scanQRCod = (res) => {
    if(!checkFnaJsApi("scanQRCode")) return;
    window.em.scanQRCode({
        needResult: 1,
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (value) {
            console.log('value', value);
            let params = {
                source: "ENTRY",
                type: "SCAN_QRCODE",
                rid: res.rid, // 发票云传过来的 id
                result: value.resultStr, // 扫码结果
            }
            sendResult('SCAN_QRCODE', params);
        },
        fail: function (err) {
            console.log('err', err);
            if (window.WeaverMobile && window.WeaverMobile.Toast)
                window.WeaverMobile.Toast.fail(err);
        }
    });
}

//选择发票   类型：1 微信  2 支付宝
const chooseInvoice = (res) => {
    if(!checkFnaJsApi("chooseInvoice")) return;
    window.em.chooseInvoice({
        type: res.invoiceType,  // 类型：1 微信  2 支付宝
        success: function (value) {
            let params = {
                source: "ENTRY",
                type: "SELECT_INVOICE",
                invoiceType: res.invoiceType, // 类型：1 微信  2 支付宝
                rid: res.rid, // 发票云传过来的 id
                list: value.setInvoiceList,
            }
            const equipment = getEquipment();
            if(equipment.isWx === false){//不是微信
                if(!checkFnaJsApi("getCpUser")) return;
                window.em.getCpUser({
                    success: function (res) {
                        params = Object.assign(params,{
                            appKey: res
                        });
                        sendResult('SELECT_INVOICE',params);
                    },
                    fail:function(err){
                        params = Object.assign(params,{
                            appKey: err
                        });
                        sendResult('SELECT_INVOICE',params);
                    }
                });
            }else{
                sendResult('SELECT_INVOICE',params);
            }
        },
        fail:function(err){
            if (window.WeaverMobile && window.WeaverMobile.Toast)
                window.WeaverMobile.Toast.fail(err);
        }
    });
}

//拍照
const takePicture = (params) => {
    if(!checkFnaJsApi("chooseImage")) return;
    let localIdArr = [];
    let num = 0;
    window.em_ssoInit().then(() => {
        window.em.chooseImage({
            count: 9, // 最大可选照片数，默认9
            sourceType: ['camera'], // 可以指定来源是相册还是相机，默认二者都有
            success: function (res) {
                let localIds = res.localIds; // 返回选定照片的本地ID列表
                localIds.forEach(function(localId){
                    window.em.getLocalImgData({
                        localId: localId,
                        success: function(res){
                            num++;
                            let data = res.localData;
                            let base64PicData = "data:image/jpeg;base64,"+data;
                            let bool = localIds.length == num ? true : false;
                            let listEle = {
                                base64:base64PicData,
                                fileName: '',
                            }
                            localIdArr.push(listEle);
                            getlocalIdData(params,localIdArr,bool);
                        }
                    });
                });

            }
        });
    }).catch((res) => {
        alert("连续拍照插件异常,使用原始插件");
    })
}     


//获取所有 发票拍照数据
const getlocalIdData = (params,data,send) => {
    if(send){ 
        let localParams = {
            source: "ENTRY",
            type: "CHOOSE_IMAGE",
            rid: params.rid, // 发票云传过来的 id,
            list:data
        }
        sendMessage(localParams);
    }
} 



// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/util/public/invoiceUtil.js